export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant02-mobile-de.165b9d86.png";